module.exports = __webpack_public_path__ + "img/image-empty.2e03a46b.svg";